import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseIsUniqueDocumentOrginalNumberWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.purchase.validation.existing-orginal-number-warning.message');
    }
}
